/**
 * Responsibility: Implement narrator perspective behavior for the ai layer.
 * Scope: Owns ai-layer concerns only; cross-layer orchestration is excluded.
 */
function toSecondPersonVerb(verb: string): string {
  const lower = String(verb ?? '').toLowerCase()
  if (!lower) return lower
  if (lower === 'is') return 'are'
  if (lower === 'was') return 'were'
  if (lower === 'has') return 'have'
  if (lower === 'does') return 'do'
  if (lower.endsWith('ies') && lower.length > 3) return `${lower.slice(0, -3)}y`
  if (/(ches|shes|sses|xes|zes|oes)$/.test(lower) && lower.length > 3) return lower.slice(0, -2)
  if (lower.endsWith('s') && lower.length > 2) return lower.slice(0, -1)
  return lower
}

export function normalizeNarratorPerspective(text: string): string {
  return String(text ?? '')
    .replace(/\bthe player character\s+(is|was|has|does|[a-z]+s)\b/gi, (_m, verb) => `you ${toSecondPersonVerb(verb)}`)
    .replace(/\bthe player\s+(is|was|has|does|[a-z]+s)\b/gi, (_m, verb) => `you ${toSecondPersonVerb(verb)}`)
    .replace(/\bthe player character's\b/gi, 'your')
    .replace(/\bplayer character's\b/gi, 'your')
    .replace(/\bthe player's\b/gi, 'your')
    .replace(/\bthe player character\b/gi, 'you')
    .replace(/\bplayer character\b/gi, 'you')
    .replace(/\bthe player\b/gi, 'you')
}
